import React from 'react';
import SkeletonWrapper from 'Components/SkeletonWrapper';
import { useTranslation } from 'react-i18next';
import { useTrackingNumbers } from 'services/Data/TrackingNumberServices';
import GridContainer from '@jumbo/components/GridContainer';
import GridItem from '@jumbo/components/GridItem';
import { Divider, Typography } from '@mui/material';
import CustomDatePicker from 'Components/CustomDatePicker/CustomDatePicker';
import useTranslateEnum from 'services/Hooks/useTranslateEnum';
import TrackingNumberCarrierEnum from 'enums/TrackingNumberCarrierEnum';

const TrackingNumberSection = ({ cart, isCartLoading }) => {
  const { t } = useTranslation();

  const { translateEnum } = useTranslateEnum();

  const { data: trackingNumbers, isLoading: gettingTrackinNumber } = useTrackingNumbers(cart?.id);

  const isLoading = isCartLoading || gettingTrackinNumber;
  return (
    <SkeletonWrapper
      isLoading={isLoading}
      component={
        <GridContainer>
          <GridItem xs={12} md={6}>
            <Typography variant="h1">{t('trackingInfo')}</Typography>
          </GridItem>
          {trackingNumbers?.map(trackingNumber => (
            <GridItem xs={12} style={{ marginTop: '1vh' }} key={trackingNumber.id}>
              <GridContainer
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}>
                <GridItem xs={6}>
                  {trackingNumber.trackingNumberCarrierEnum > 0 && (
                    <Typography>
                      {translateEnum(TrackingNumberCarrierEnum, trackingNumber.trackingNumberCarrierEnum)}
                    </Typography>
                  )}
                </GridItem>

                <GridItem xs={6}>
                  {trackingNumber?.number && trackingNumber?.number !== 'N/A' && (
                    <Typography>{trackingNumber?.number}</Typography>
                  )}
                </GridItem>

                {trackingNumber?.carrierDescription && (
                  <GridItem xs={12}>
                    <Typography>{trackingNumber?.carrierDescription}</Typography>
                  </GridItem>
                )}

                <GridItem xs={6}>
                  <CustomDatePicker
                    labelText={t('estimatedArrival')}
                    dateFormat={t('date_format_with_time')}
                    formControlProps={{ fullWidth: true }}
                    datePickerProps={{
                      value: trackingNumber?.estimatedArrival,
                      disabled: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={6}>
                  <CustomDatePicker
                    labelText={t('departure')}
                    dateFormat={t('date_format_with_time')}
                    formControlProps={{ fullWidth: true }}
                    datePickerProps={{
                      value: trackingNumber?.departure,
                      disabled: true,
                    }}
                  />
                </GridItem>

                {trackingNumber?.description && (
                  <GridItem xs={12}>
                    <Typography>{trackingNumber?.description}</Typography>
                  </GridItem>
                )}

                <GridItem xs={12}>
                  <Divider />
                </GridItem>
              </GridContainer>
            </GridItem>
          ))}
        </GridContainer>
      }
    />
  );
};

export default TrackingNumberSection;
